/**
 * See swiper docu at https://swiperjs.com/swiper-api#methods--properties
 */
window.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelectorAll('.stage_news_swiper');

  if (slider.length) {
    slider.forEach((item) => {
      const textSlider = item.querySelector('.text-swiper');
      const textSliderPagination = item.querySelector('.swiper-pagination');
      const textSliderPrev = item.querySelector('.swiper-button-next');
      const textSliderNext = item.querySelector('.swiper-button-prev');
      const imgSliderEle = item.querySelector('.img-swiper');

      let textSwiper = new Swiper(textSlider, {
        slidesPerView: 1,
        autoHeight: false,
        effect: 'fade',
        grabCursor: true,
        loop: true,
        speed: 500,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: textSliderPagination,
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: textSliderPrev,
          prevEl: textSliderNext,
        },
      });

      let imgSwiper = new Swiper(imgSliderEle, {
        slidesPerView: 1,
        autoHeight: false,
        effect: 'slide',
        grabCursor: true,
        loop: true,
        speed: 500,
        // thumbs: {
        //   swiper: textSwiper,
        // },
        // pagination: {
        //   el: textSliderPagination,
        //   type: 'bullets',
        //   clickable: true
        // },
        // navigation: {
        //   nextEl: textSliderPrev,
        //   prevEl: textSliderNext,
        // },
      });

      // Syncs controller for each swiper (Avoid solution via thumbs)
      textSwiper.controller.control = imgSwiper;
      imgSwiper.controller.control = textSwiper;

      // Events
      // Swipe images when swiped on text
      // activeIndexChange
      // realIndexChange
      // slideChangeTransitionStart
      // slideChange
      // beforeTransitionStart
      // touchEnd
      // update
      // snapIndexChange

      // textSwiper.on('slideChange', function (e) {
      //   console.log(e);
      //   if(imgSwiper.activeIndex != textSwiper.activeIndex){
      //     imgSwiper.slideTo(textSwiper.activeIndex);
      //     console.log("hello", e);
      //   }
      // });

    });
  }
});
